import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const EnableCodelistInNewProjectsStep = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<>
			<p className="text-base">{translation.description}</p>

			<img
				src="/img/codelist-changelog/enable-for-new.gif"
				alt="Kodelister i nye prosjekter"
				className="mt-6 w-full"
			/>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		description: 'You may enable codelists when creating a project.'
	},

	[LanguageType.Norwegian]: {
		description: 'Du kan skru på kodelister når du oppretter et prosjekt.'
	}
};
